import { INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS } from "config/constants";
import { getQuestionById, isHTMLContentEmpty, isValidValue } from "helpers/common";
import { stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, date, object, string } from "yup";

const getValidationSchema = (currentTab, reportQuestions) => {
  switch (currentTab) {
    case 1:
      return object().shape({
        screening_date: date()
          .nullable()
          .required('Screening date is required'),
      });
    case 2:
      const locationQuestion = getQuestionById(INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location, reportQuestions);
      const inputLabels = locationQuestion?.question_dd_labels || [];
      const labelsValidation = {};
      inputLabels?.length && inputLabels.forEach(label => {
        labelsValidation[label] = stringRequiredSchema;
      })

      return object({
        // [INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.diagnosis]: object({
        //   other_details: object({
        //     radio_tag: stringRequiredSchema
        //   }),
        //   answer: string().when('other_details.radio_tag', {
        //     is: 'diagnosis',
        //     then: (schema) => stringRequiredSchema,
        //     otherwise: (schema) => stringOptionalSchema,
        //   }),
        // }),
        [INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.location]: object({
          other_details: object({
            radio_tag: stringRequiredSchema,
            dd_labels: object({
              ...labelsValidation
            }).when('radio_tag', {
              is: "Virtual",
              then: (schema) => object(labelsValidation).required(),
              otherwise: (schema) => object().strip(),
            }),
          }),
          answer: stringOptionalSchema,
        }),
        [INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS.session_updates]: object({
          answer: stringRequiredSchema,
        }),
      });
    case 3:
      return object({
        recommendation: array()
          .of(
            object().shape({
              answers: string().test("validate-by-index", function (value) {
                const index = Number(this.path.match(/\d+/)?.[0]);

                // First recommendation required
                if (index === 0) {
                  if (!value || !isValidValue(value) || isHTMLContentEmpty(value)) {
                    return this.createError({
                      message: "Required",
                    });
                  }
                  return true;
                }

                // Second recommendation optional
                if (index === 1) {
                  if (!value || !isValidValue(value) || isHTMLContentEmpty(value)) return true; // allow empty
                  if (!isValidValue(value) || isHTMLContentEmpty(value)) {
                    return this.createError({
                      message: "Required",
                    });
                  }
                }

                return true;
              }),
            })
          )
          .length(2, "Must have exactly 2 recommendations"),
      });
  }
}

export default getValidationSchema;